import { motion, AnimatePresence } from 'motion/react';
import React from 'react';

import {
  UiTypography,
  UiTypographyColorType,
} from '@/components/ui/Typography';

import { ChatMessageStyles } from './ChatMessage.styles';

const parseItalicText = (text: string): React.ReactNode[] => {
  const parts = text.split(/(\*[^*]+\*)/g);

  return parts.map((part, index) => {
    if (part.startsWith('*') && part.endsWith('*') && part.length > 2) {
      const italicText = part.slice(1, -1);
      return (
        <em key={index} style={{ fontStyle: 'italic' }}>
          {italicText}
        </em>
      );
    }
    return part;
  });
};

interface ChatMessageProps {
  content: string;
  variant: 'sent' | 'received';
  show?: boolean;
  delay?: number;
  color?: UiTypographyColorType;
}

export const ChatMessage: React.FC<ChatMessageProps> = ({
  content,
  variant,
  show = true,
  delay = 0,
  color,
}) => {
  return (
    <AnimatePresence>
      {show && (
        <motion.div
          initial={{ opacity: 0, scale: 0.95 }}
          animate={{ opacity: 1, scale: 1 }}
          exit={{ opacity: 0, scale: 0.95 }}
          layout
          transition={{
            duration: 0.3,
            delay,
            ease: [0.25, 0.46, 0.45, 0.94],
            layout: { duration: 0.2 },
          }}
        >
          <ChatMessageStyles variant={variant}>
            <UiTypography variant="body-large" component="span" color={color}>
              {parseItalicText(content)}
            </UiTypography>
          </ChatMessageStyles>
        </motion.div>
      )}
    </AnimatePresence>
  );
};
